import React from "react";
import { Link } from "react-router-dom";

const SeoCTA = ({
  title = "Generate Spanish subtitles with SubtitleTsunami",
  description = "Upload your English video, create Spanish subtitles, and download your finished subtitled video.",
  buttonText = "Start Free Upload",
}) => {
  return (
    <section className="my-10 rounded-3xl border border-cyan-300/20 bg-slate-950 p-6 text-center shadow-2xl shadow-cyan-950/30">
      <p className="mb-2 text-sm font-semibold uppercase tracking-[0.25em] text-cyan-300">
        SubtitleTsunami
      </p>

      <h2 className="mb-3 text-2xl font-black text-white md:text-3xl">
        {title}
      </h2>

      <p className="mx-auto mb-6 max-w-2xl text-base leading-7 text-slate-300">
        {description}
      </p>

      <Link
        to="/"
        className="inline-flex items-center justify-center rounded-2xl bg-cyan-300 px-6 py-3 text-base font-black text-slate-950 shadow-lg shadow-cyan-950/40 transition hover:-translate-y-0.5 hover:bg-cyan-200"
      >
        {buttonText}
      </Link>
    </section>
  );
};

export default SeoCTA;